import { CriterionDetailsDialogViewModel } from '@Criteria/Hierarchies/Components/CriterionDetailsDialog';
import CriterionDetailsDialog from "@Criteria/Hierarchies/Components/CriterionDetailsDialog.vue";
import WeightsViewerDialog from "@Criteria/Weights/Components/WeightsViewerDialog.vue";
import { ExportWeightsToXlsFromPanelistVotesCommandV1 } from "@Criteria/Weights/Domain/commands-core";
import CriteriaWeightsCommands from "@Criteria/Weights/Domain/commands-vue-component";
import CriteriaWeightsQueries from "@Criteria/Weights/Domain/queries-vue-component";
import { WeightsViewerReadModel } from "@Criteria/Weights/Domain/readmodels";
import PanelistConsistencyAnalysisDialog from '@Evaluation/CriteriaSurveys/Components/PanelistConsistencyAnalysisDialog.vue';
import { ExportPanelistVotesToXlsCommandV1 } from "@Evaluation/CriteriaSurveys/Domain/commands-core";
import CriteriaSurveyCommands from '@Evaluation/CriteriaSurveys/Domain/commands-vue-component';
import CriteriaSurveysQueries from '@Evaluation/CriteriaSurveys/Domain/queries-vue-component';
import { PanelistConsistencyAnalysisReadModel, PanelistSurveyDashboardPageReadModel, SurveyDashboardContextReadModel } from "@Evaluation/CriteriaSurveys/Domain/readmodels";
import { IEvaluationCommand } from '@Evaluation/cqrs';
import { numCompare, strCompare } from '@common/Common';
import { Component, mixins } from 'vue-facing-decorator';

@Component({
    components: { PanelistConsistencyAnalysisDialog, WeightsViewerDialog, CriterionDetailsDialog }
})
export default class PanelistSurveyDashboardPage extends mixins(CriteriaSurveysQueries, CriteriaSurveyCommands, CriteriaWeightsCommands, CriteriaWeightsQueries)
{
    get workspaceId() { return Number.parseInt(this.$route.params.workspaceId); }
    get surveyId(): number { return Number.parseInt(this.$route.params.surveyId) }
    get projectUserId(): number { return Number.parseInt(this.$route.params.projectUserId) }

    initialized: boolean = false;
    orderByProgressAsc: boolean = true;
    panelistConsistencyAnalysis: PanelistConsistencyAnalysisReadModel = null;
    panelistConsistencyAnalysisOpened: boolean = false;
    weightsViewer: WeightsViewerReadModel = null;
    weightsViewerOpened: boolean = false;
    criterionDetailsDialog: CriterionDetailsDialogViewModel = new CriterionDetailsDialogViewModel();

    rm: PanelistSurveyDashboardPageReadModel = null;

    get viewTemplate(): string
    {
        if (this.initialized === false) { return "loading"; }
        else if (this.rm.IsClosed === true) { return "closed"; }
        else if (this.rm.SurveyQuestionsCount === 0) { return "empty"; }
        else { return "default"; }
    }

    get criteriaView(): SurveyDashboardContextReadModel[]
    {
        const critCompare = (a: SurveyDashboardContextReadModel, b: SurveyDashboardContextReadModel) =>
        {
            let progressCompare = numCompare(a.Progress, b.Progress);

            if (this.orderByProgressAsc === true)
            {
                progressCompare *= -1;
            }

            return progressCompare === 0 ? strCompare(a.Path, b.Path) : progressCompare;
        }

        return this.rm.Contexts.sort((a, b) => critCompare(a, b));
    }

    Refresh()
    {
        this.initialized = false;
        this.runPanelistSurveyDashboardPageQueryV1(this.workspaceId, this.surveyId, this.projectUserId);
    }


    showRespondentConsistencyAnalysis()
    {
        this.panelistConsistencyAnalysis = null;
        this.panelistConsistencyAnalysisOpened = true;
        this.runPanelistConsistencyAnalysisQueryV1(this.workspaceId, this.rm.ProjectId, this.rm.EvalModelId, this.surveyId, this.projectUserId);
    }

    showWeightsViewer()
    {
        this.weightsViewer = null;
        this.weightsViewerOpened = true;
        this.runPanelistWeightsViewerQueryV1(this.workspaceId, this.rm.ProjectId, this.rm.EvalModelId, this.projectUserId);
    }

    showCriterionDetails(c: SurveyDashboardContextReadModel)
    {
        this.criterionDetailsDialog.show(c.Name, c.Path, c.Description);
    }


    handleExportPanelistVotesToXlsCommand()
    {
        this.invokeExportPanelistVotesToXlsCommandV1(this.workspaceId, this.rm.ProjectId, this.rm.EvalModelId, this.surveyId, this.projectUserId);
    }

    handleExportWeightsToXlsFromPanelistVotesCommand(projectUserId: number)
    {
        this.invokeExportWeightsToXlsFromPanelistVotesCommandV1(this.workspaceId, this.rm.ProjectId, this.rm.CriteriaHierarchyId, this.rm.EvalModelId, this.projectUserId);
    }


    mounted()
    {
        this.runPanelistSurveyDashboardPageQueryV1(this.workspaceId, this.surveyId, this.projectUserId);
    }

    onSetModel(model: any, modelName: string)
    {
        if (modelName == "PanelistSurveyDashboardPageReadModel")
        {
            this.rm = model as PanelistSurveyDashboardPageReadModel;
            this.initialized = true;
        }
        else if (modelName == "PanelistConsistencyAnalysisReadModel")
        {
            this.panelistConsistencyAnalysis = model as PanelistConsistencyAnalysisReadModel;
        }
        else if (modelName == "WeightsViewerReadModel")
        {
            this.weightsViewer = model as WeightsViewerReadModel;
        }
    }

    onCommandSucceed(cmd: IEvaluationCommand, correlationId: string, result: any)
    {
        if (ExportPanelistVotesToXlsCommandV1.matchType(cmd))
        {
            location.href = result;
        }
        else if (ExportWeightsToXlsFromPanelistVotesCommandV1.matchType(cmd))
        {
            location.href = result;
        }
    }
}